export const queryKeys = {
  me:           ['me'] as const,
  trades:       (params?: unknown) => ['trades', params] as const,
  correlations: (params?: unknown) => ['correlations', params] as const,
  annotationOptions: ['correlations', 'annotation-options'] as const,
  closedTrades: (params?: unknown) => ['closed-trades', params] as const,
  // Position layer — both live under the ['positions'] root so the existing
  // trades.changed → ['positions'] invalidation (and the new positions.changed) covers them.
  openPositions:   (account?: string) => ['positions', 'open', { account }] as const,
  closedPositions: (params?: unknown) => ['positions', 'closed', params] as const,
  statistics:   (kind: string, params?: unknown) => ['statistics', kind, params] as const,
  // Dashboard prop-firm rule-template evaluation (/api/v1/prop-eval). Lives under the
  // ['statistics'] root ON PURPOSE: the realtime trades/correlations/positions.changed
  // invalidations all target ['statistics'], so the card refreshes with every other widget.
  propEval:     (params?: unknown) => ['statistics', 'prop-eval', params] as const,
  lastUpdate:   (params?: unknown) => ['last-update', params] as const,
  firstTrade:   (params?: unknown) => ['first-trade', params] as const,
  cqgStatus:    ['cqg', 'status'] as const,
  quotes:       ['quotes'] as const,
  account:      (account?: string) => ['account', 'summary', { account }] as const,
  cqgPositions: (account?: string) => ['cqg', 'positions', { account }] as const,
  plans:        ['billing', 'plans'] as const,
  // The one-off AI-credit top-up pack (`GET /billing/credit-pack`, 2026-08-14). Sits beside `plans`
  // under the ['billing'] root; the pack's price/size only changes with a config redeploy, so the
  // query is long-lived (5 min staleTime) and never invalidated by anything the client does.
  creditPack:   ['billing', 'credit-pack'] as const,
  // The Calendar page's economic events (2026-09-26), per date range; global data, never invalidated.
  economicEvents: (from: string, to: string) => ['economic-calendar', from, to] as const,
  // One event's reference entry + history (2026-10-14), fetched when its details popover opens; kept an hour.
  economicEventReference: (id: string) => ['economic-calendar', 'reference', id] as const,
} as const;
